/* Page scroll lock, shared by every overlay: the bag, the booking sheet, the
 * menu drawer, search and the collection filters.
 *
 * Tim, 5 Oct: while any of them is open the page behind must not move, until
 * the last one closes. Each overlay used to set `body.style.overflow` itself,
 * which (a) iPhones only partly honour, so a drag on the scrim or past the end
 * of a panel's list still scrolled the page, and (b) let one overlay closing
 * unlock the page under another still open (menu to booking).
 *
 *   DDJScrollLock.set('cart', true)   lock, owned by 'cart'
 *   DDJScrollLock.set('cart', false)  release; the page frees when no owner is left
 *
 * Locked, it does three things:
 *   - overflow hidden on <html> and <body>
 *   - overscroll-behavior none on <html>, so a panel's own list cannot hand its
 *     scroll on to the page (src/input.css, `html.is-scroll-locked`)
 *   - a touchmove guard for iOS: a vertical drag is cancelled unless it lands in
 *     something that can scroll that way and is not already at that end. A
 *     sideways drag (sliders, the price range) is left alone.
 * The page is not moved or re-positioned, so the header stays where it is.
 */
(function () {
  'use strict';

  var owners = {};
  var startX = 0;
  var startY = 0;
  var root = document.documentElement;

  function locked() {
    for (var k in owners) if (owners[k]) return true;
    return false;
  }

  function scrollable(el) {
    while (el && el !== document.body && el !== root) {
      if (el.scrollHeight > el.clientHeight + 1) {
        var oy = window.getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll') return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function onTouchStart(event) {
    if (event.touches.length !== 1) return;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }

  function onTouchMove(event) {
    if (!locked() || event.touches.length !== 1) return;
    var dx = event.touches[0].clientX - startX;
    var dy = event.touches[0].clientY - startY;
    if (Math.abs(dx) > Math.abs(dy)) return;
    var box = scrollable(event.target);
    if (!box) {
      if (event.cancelable) event.preventDefault();
      return;
    }
    var atTop = box.scrollTop <= 0;
    var atBottom = box.scrollTop + box.clientHeight >= box.scrollHeight - 1;
    if ((atTop && dy > 0) || (atBottom && dy < 0)) {
      if (event.cancelable) event.preventDefault();
    }
  }

  function apply() {
    var on = locked();
    root.classList.toggle('is-scroll-locked', on);
    document.body.style.overflow = on ? 'hidden' : '';
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false });

  window.DDJScrollLock = {
    set: function (owner, on) {
      owners[owner] = !!on;
      apply();
    },
    isLocked: locked
  };
})();
